export default "__VITE_ASSET__DwtOItn4__"